import { useMutation } from '@apollo/client';
import { UNAPPROVE_WELD } from '@bechtel/client-gql';
import { Scalars, UnApproveWeldPayload } from '@bechtel/types';

export function useUnApproveWeld(
  onCompleted: (data) => void,
  onError: (error) => void,
  refetchQueries: string[]
): //@ts-ignore type changed in @apollo/client
MutationTuple<{ unApproveWeldPayload: UnApproveWeldPayload }, { commodityMilestoneId: Scalars['ID'] }> {
  const response = useMutation<{ unApproveWeldPayload: UnApproveWeldPayload }, { commodityMilestoneId: Scalars['ID'] }>(
    UNAPPROVE_WELD,
    {
      notifyOnNetworkStatusChange: true,
      onCompleted: (data) => {
        if (onCompleted) onCompleted(data);
      },
      onError: (error) => {
        if (onError) onError(error);
      },
      refetchQueries: refetchQueries,
    }
  );
  return response;
}
